import React, { useEffect, useState } from 'react'
import { Collapse, Icon, Typography, Input, Row, Col } from 'antd'
import { Button, Widget } from '@digital/ui'
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { InputLabel, Visibility } from '@app/components';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import TableVendorList from './TableVendorList';
import { getLoggedId } from '@app/helpers';
import { getByUsuarioIdSasFornecedorOc } from '@app/api/sas/sasFornecedor';
import SelectIncluirGestorTecnico from './SelectIncluirGestorTecnico';
import SelectIncluirGerenteArea from './SelectIncluirGerenteArea';
import InputComentarioGerenteArea from './InputComentarioGerenteArea';

import { useRecoilState, useRecoilValue } from 'recoil'
import { dadosGeraisState, dadosIdentificacaoState, ordemCompraIdState, reloadState, vendorListState, stepState } from '../atoms'
import { downloadArquivosOrdemCompra } from '@app/api/sas/sasDocumentoOrdemCompra';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { isObjNotEmpty } from '@app/helpers/objHelper';

const { Panel } = Collapse;
const { Title } = Typography;

interface Props {
    statusDisable: boolean
}

const WidgetAcompanhamentoProcesso = (props: Props) => {
    const { statusDisable } = props
    const ordemCompraId: string = useRecoilValue(ordemCompraIdState);
    const vendorList = useRecoilValue(vendorListState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const [reload, setReload] = useRecoilState(reloadState);

    const dadosIdentificacao = useRecoilValue(dadosIdentificacaoState);
    const step = useRecoilValue(stepState);

    const [statusCartaAgradecimento, setStatusCartaAgradecimento] = useState(false);

    const [loggedId] = useState(getLoggedId() || "");
    const [ehComprador, setEhComprador] = useState(false);
    const [statusCodigo, setStatusCodigo] = useState(0)
    const [fornecedorOcId, setFornecedorOcId] = useState("");

    const onUpdate = () => {
        setReload(!reload)
    }

    useEffect(() => {
        if (ordemCompraId && dadosGerais) {
            setEhComprador(dadosGerais.compradorId == loggedId);
            getByUsuarioIdSasFornecedorOc(loggedId).then((result) => {
                if (result && result.id) {
                    setFornecedorOcId(result.id);
                }
            });
        }
    }, [dadosGerais, reload])

    useEffect(() => {
        if (
            (statusCodigo == EStatusOrdemCompra.AguardandoAprovacaoAssinatura || statusCodigo == EStatusOrdemCompra.Concluido) &&
            (hasPermission(["SAS_ENVIAR_CARTA_CONVITE"]) || ehComprador) &&
            vendorList.length > 1 && dadosGerais && !dadosGerais.statusCartaAgradecimento
        ) {
            setStatusCartaAgradecimento(true);
        }
    }, [statusCodigo, dadosGerais, vendorList]);

    const downloadTudoAnexosSolicitacaoEsclarecimentos = () => {
        downloadArquivosOrdemCompra({
            ordemCompraId: ordemCompraId,
            ordemCompraNumero: dadosIdentificacao.numero,
            nomeArquivo: 'duvidas_tecnicas_proponentes',
            sasTipoDocumentoOrdemCompraId: EGuidTipoSasDocumento.EnvioEsclarecimentosTecnicos,
            isPropostas: true
        })
    }

    return (
        <Collapse
            bordered={false}
            defaultActiveKey="acompanhamentoContratacao"
            expandIcon={() => <Icon type="arrows-right_4" />}
        >
            <Panel
                key="acompanhamentoContratacao"
                header={`${step.ordem} - ${step.nome}`}
            >
                <Widget >
                    <Row>
                        <Visibility
                            visible={hasPermission(["SAS_VISUALIZAR_VENDOR_LIST"]) ||
                                hasPermissionPerfil([
                                    EGuidPerfilAcesso.GerenciaSenior,
                                    EGuidPerfilAcesso.AdministradorContratoMRN,
                                ])
                            }
                        >
                            <div style={{ marginTop: 0, marginBottom: 30 }}>

                                <TableVendorList
                                    statusCodigo={statusCodigo}
                                    onUpdateDadosGerais={onUpdate}
                                    ehComprador={ehComprador}
                                    fornecedorOcId={fornecedorOcId}
                                />

                                <Visibility
                                    visible={isObjNotEmpty(step) && 'fluxoEtapaId' in step && step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante}
                                >
                                    <Button
                                        style={{ float: 'right' }}
                                        onClick={downloadTudoAnexosSolicitacaoEsclarecimentos}>
                                        Baixar Tudo
                                    </Button>
                                </Visibility>
                            </div>
                        </Visibility>
                    </Row>

                    {!hasPermissionPerfil([EGuidPerfilAcesso.FornecedorSAS]) && dadosGerais && (
                        <div style={{ marginTop: 30, marginBottom: 30 }}>
                            <Row align="middle" aria-orientation="horizontal">
                                <Col>
                                    <SelectIncluirGestorTecnico
                                        ordemCompraId={ordemCompraId || ""}
                                        gestorAtualId={dadosGerais.gestorTecnicoId || ""}
                                        onUpdateDadosGerais={onUpdate}
                                        statusDisable={statusDisable}
                                    />
                                </Col>
                                <Col>
                                    <SelectIncluirGerenteArea
                                        ordemCompraId={ordemCompraId || ""}
                                        gerenteAtualId={dadosGerais.gerenteAreaId || ""}
                                        onUpdateDadosGerais={onUpdate}
                                        statusDisable={statusDisable}
                                    />
                                </Col>
                                <Col>
                                    <InputLabel label="Mínimo Proponentes" span={4}>
                                        <Input
                                            value={dadosGerais.minimoProponentes}
                                            disabled
                                        />
                                    </InputLabel>
                                </Col>
                                {statusCodigo == EStatusOrdemCompra.AguardandoValidacao ||
                                    dadosGerais.comentarioGerenteArea ? (
                                    <Col>
                                        <InputComentarioGerenteArea
                                            ordemCompraId={ordemCompraId || ""}
                                            comentarioGerenteArea={
                                                dadosGerais.comentarioGerenteArea || ""
                                            }
                                            statusAguardandoAvaliacao={
                                                statusCodigo ==
                                                EStatusOrdemCompra.AguardandoValidacao
                                            }
                                            onUpdateDadosGerais={onUpdate}
                                        />
                                    </Col>
                                ) : (
                                    () => { }
                                )}
                            </Row>
                        </div>
                    )}
                </Widget>
            </Panel>
        </Collapse>
    )
}

export default WidgetAcompanhamentoProcesso